function Footer(props) {
    return (
        <div className="footer">
            <div className="container flex">
            <div className="footer-right">
                <h1 className="footer-logo">JagdishDev</h1>
                <p className="footer-copyright">© All right are reserved | 2021</p>
            </div>
            <div className="footer-left">
                <div className="share-icons">
                    <a href={props.LinkedinUrl} target="_blank">LinkedIn</a>
                    <a href={props.GithubUrl} target="_blank">Github</a>
                </div>
            </div>
            </div>
      </div>
    )
};

export default Footer;